import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from '../../../components/UI/Layout/Layout';
import MotorDataHPItems from '../../../components/MotorDataComponents/MotorDataHPItems/MotorDataHPItems';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

class MotorDataHPPage extends Component {
  goBackHandler = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      country,
      language,
      selectedUSA,
      selectedCanadaEN,
      selectedCanadaFR
    } = this.props;
    
    return (
      <Layout
        clicked={this.goBackHandler}
        title={LocalizedStrings[language].motorData}
        selectedCanadaEN={selectedCanadaEN}
        selectedCanadaFR={selectedCanadaFR}
        selectedUSA={selectedUSA}
        country={country}
        language={language}
      >
        <MotorDataHPItems country={country} language={language} />
      </Layout>
    );
  }
}

MotorDataHPPage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(MotorDataHPPage);
